export const COL_COLOR_MAPPING = [
  {
    background: "bg-gradient-to-r from-swdc-cool-gray-200 to-swdc-silver-200",
    text: "text-swdc-cool-gray-200",
    btnColor:
      "bg-swdc-cool-gray-200 ring-swdc-cool-gray-200 relative isolate before:absolute before:inset-[0.4375rem] before:-z-10 before:rounded-[4px] before:bg-[#fdfdfd]",
  },
  {
    background: "bg-swdc-silver-200",
    text: "text-swdc-silver-200",
    btnColor:
      "bg-swdc-silver-200 ring-swdc-silver-200 relative isolate before:absolute before:inset-[0.4375rem] before:-z-10 before:rounded-[4px] before:bg-[#eff4f4] hover:before:bg-[#f7f9f9]",
  },
  {
    background: "bg-swdc-silver-300",
    text: "text-swdc-silver-300",
    btnColor:
      "bg-swdc-silver-300 ring-swdc-silver-300 relative isolate before:absolute before:inset-[0.4375rem] before:-z-10 before:rounded-[4px] before:bg-[#d9e3e3] hover:before:bg-[#ecf1f1]",
  },
  {
    background: "bg-swdc-silver-400",
    text: "text-swdc-silver-400",
    btnColor:
      "bg-swdc-silver-400 ring-swdc-silver-400 relative isolate before:absolute before:inset-[0.4375rem] before:-z-10 before:rounded-[4px] before:bg-[#c5d1d5] hover:before:bg-[#e2e8ea]",
  },
  {
    background: "bg-swdc-orange-400",
    text: "text-swdc-orange-400",
    btnColor:
      "bg-swdc-orange-400 ring-swdc-orange-400 relative isolate before:absolute before:inset-[0.4375rem] before:-z-10 before:rounded-[4px] before:bg-[#ffc099] hover:before:bg-[#ffe0cc]",
  },
] as const;
